module.exports = __webpack_public_path__ + "img/logo.43df9fe8.png";